import React from "react";
import { Link } from "react-router-dom";
import { routes } from "src/constants/routes";
import { NavBar } from "./NavBar";

// #region -------------- Component -------------------------------------------------------------------

export class Header extends React.PureComponent {
  public render() {
    return (
      <header className="rb-header">
        <div className="container">
          <div className="rb-logo">
            <Link to={routes.manager}>
              <img width={140} height={35} src="/logo_c.svg" alt="logo-white" />
            </Link>
          </div>
          <div className="rb-navbar-container">
            <NavBar />
          </div>
          {/* spacer */}
          <div
            className="hidden-sm hidden-xs"
            style={{ width: 140, height: 1 }}
          ></div>
        </div>
        {/* </div> */}
      </header>
    );
  }
}

// #endregion
